import { render } from "./AllChapters.vue?vue&type=template&id=ac4fd738"
import script from "./AllChapters.vue?vue&type=script&lang=js"
export * from "./AllChapters.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__